import {createFileRoute} from '@tanstack/react-router';
import {AgreementSuccessPage} from 'features/agreement-cancellation/pages/SuccessPage/AgreementSuccessPage';

export const Route = createFileRoute(
  '/_protected/agreements/$agreementId/success',
)({
  component: AgreementSuccessPage,
  staticData: {crumbKey: 'navigation.agreements'},
});
